import React from "react";
import { Icon } from "../../components";
import { PriceRanges } from "../../data";
import { useMediaQuery } from "../../hooks";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { useFromPriceLabel } from "../hooks/use_from_price_label";
import styles from "./price_label.module.css";
import classNames from "classnames";

interface PriceLabelProps {
  priceRanges?: PriceRanges;
  currency: string | null;
  dailySavingPercent?: number;
  hourlyPrice?: number;
}

export function PriceLabel({
  priceRanges,
  dailySavingPercent,
  currency,
  hourlyPrice,
}: PriceLabelProps) {
  const { fbt, locale } = useI18n();
  const { device } = useMediaQuery();
  const { hourlyPriceLabel, dailyPriceLabel } = useFromPriceLabel(
    priceRanges,
    hourlyPrice,
    currency,
    locale.languageTag,
    fbt
  );

  if (device === "mobile") {
    return (
      <div>
        <div>
          <b>{hourlyPriceLabel}</b>
        </div>
        <div className={styles.mobileSavingWrapper}>
          {fbt("or")}

          <>
            {" "}
            <Icon name="price-tag" color="var(--bs-secondary)" size={16} />{" "}
          </>

          <b>{dailyPriceLabel}</b>
        </div>
      </div>
    );
  }

  return (
    <PriceLabelDesktop
      priceRanges={priceRanges}
      dailySavingPercent={dailySavingPercent}
      currency={currency}
      hourlyPrice={hourlyPrice}
    />
  );
}

export const PriceLabelDesktop = ({
  priceRanges,
  dailySavingPercent,
  currency,
  hourlyPrice,
}: PriceLabelProps) => {
  const { fbt, locale } = useI18n();
  const { hourlyPriceLabel, dailyPriceLabel } = useFromPriceLabel(
    priceRanges,
    hourlyPrice,
    currency,
    locale.languageTag,
    fbt
  );

  return (
    <div className={styles.component}>
      <div>
        <div className={styles.priceTitleWrapper}>
          <div className={styles.priceTitle}>{fbt("Hourly")}</div>
        </div>
        <div className={styles.priceText}>{hourlyPriceLabel}</div>
      </div>
      <div>
        <div>
          <div className={styles.priceTitleWrapper}>
            <div className={styles.priceTitle}>{fbt("Daily")}</div>
            {!!dailySavingPercent && (
              <div className={classNames(styles.savingTag, "daily-saving-tag")}>
                <Icon name="price-tag" color="var(--bs-body-bg)" size={16} />{" "}
                {fbt("Save")} {dailySavingPercent}%
              </div>
            )}
          </div>
        </div>
        <div className={styles.priceText}>{dailyPriceLabel}</div>
      </div>
    </div>
  );
};
